<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner">
    <div class="container">
        <div class="goBackBtn text-end px-5">
           
        </div>
        <div class="inner-title text-center">
            <h3>سياسة الخصوصية</h3>
        </div>
    </div>
</div>

<div class="privacy-policy-area ptb-100">
    <div class="container">
        <div class="single-content">
            <h3 class="title-h3">سياسة الخصوصية لتطبيق وصلة</h3>
            <p>نحن في وصلة نأخذ خصوصيتك على محمل الجد ونلتزم بحماية معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام ومشاركة المعلومات التي نجمعها من مستخدمي تطبيقنا (المشار إليه بـ "التطبيق"). باستخدام تطبيق وصلة، فإنك توافق على جمع واستخدام المعلومات وفقًا لهذه السياسة.</p>
            
            <h4>1- المعلومات التي نجمعها</h4>
            <p>نجمع عدة أنواع من المعلومات لتقديم وتحسين خدمتنا:</p>
            
            <h5>1.1 المعلومات الشخصية:</h5>
            <p>عند التسجيل أو إجراء عملية شراء، قد نجمع اسمك ورقم هاتفك وعنوان بريدك الإلكتروني وعنوان التوصيل الخاص بك.</p>
            <p>تتم معالجة معلومات الدفع مثل تفاصيل البطاقة الائتمانية أو بطاقة الخصم من خلال بوابة دفع آمنة تابعة لطرف ثالث ولا يتم تخزينها بواسطة وصلة.</p>
            
            <h5>1.2 معلومات الجهاز:</h5>
            <p>قد نجمع معلومات حول الجهاز الذي تستخدمه، بما في ذلك نوع الجهاز، نظام التشغيل، والمعرفات الفريدة للجهاز.</p>
            
            <h5>1.3 معلومات الموقع:</h5>
            <p>بموافقتك، نقوم بجمع معلومات الموقع في الوقت الفعلي لتقديم خدمات التوصيل بدقة. يمكنك تفعيل أو تعطيل خدمات الموقع من خلال إعدادات جهازك.</p>
            
            <h5>1.4 بيانات الاستخدام:</h5>
            <p>نجمع معلومات حول كيفية استخدامك للتطبيق، بما في ذلك الصفحات أو الميزات التي تتفاعل معها، الوقت والتاريخ لاستخدامك، وغيرها من البيانات التشخيصية لتحسين خدماتنا.</p>
            
            <h4>2- كيفية استخدام معلوماتك</h4>
            <p>نستخدم معلوماتك لـ:</p>
            <ul>
                <li>تقديم وتشغيل وصيانة التطبيق.</li>
                <li>معالجة الطلبات وتوصيل المنتجات إلى عنوانك.</li>
                <li>تحسين أداء التطبيق وتجربة المستخدم.</li>
                <li>التواصل معك، بما في ذلك دعم العملاء وتقديم التحديثات والعروض الترويجية.</li>
                <li>ضمان أمان التطبيق ومنع الاحتيال أو إساءة الاستخدام.</li>
            </ul>
            
            <h4>3- مشاركة معلوماتك</h4>
            <p>تحترم وصلة خصوصيتك ولن تبيع معلوماتك الشخصية. ومع ذلك، قد نشارك معلوماتك في الحالات التالية:</p>
            <ul>
                <li><strong>البائعون:</strong> لتلبية طلباتك، نشارك معلوماتك (الاسم، العنوان، وتفاصيل الاتصال) مع البائعين الذين تقوم بالطلب منهم.</li>
                <li><strong>مزودو الخدمات:</strong> نعمل مع مقدمي خدمات طرف ثالث يساعدوننا في معالجة الدفع، استضافة التطبيق، التحليلات، ودعم العملاء.</li>
                <li><strong>المتطلبات القانونية:</strong> قد نكشف عن معلوماتك إذا طُلب منا ذلك بموجب القانون أو استجابةً لطلبات قانونية صالحة.</li>
            </ul>
            
            <h4>4- أمان البيانات</h4>
            <p>نستخدم تدابير أمان معقولة تجاريًا لحماية معلوماتك من الوصول غير المصرح به أو الكشف أو التغيير. ومع ذلك، لا توجد طريقة نقل عبر الإنترنت أو طريقة تخزين إلكترونية آمنة تمامًا. بينما نسعى لحماية بياناتك، لا يمكننا ضمان أمانها الكامل.</p>
            
            <div class="highlight">
                <h4>5- حقوقك واختياراتك</h4>
                <p>لديك الحق في:</p>
                <ul>
                    <li>الوصول إلى معلوماتك الشخصية وتحديثها في أي وقت من خلال إعدادات حسابك.</li>
                    <li>لديك الحق في حذف حسابك ومعلوماتك الشخصية، وفقًا للالتزامات القانونية أو الأسباب التجارية المشروعة.</li>
                    <li>إلغاء الاشتراك في تلقي الاتصالات التسويقية باتباع تعليمات إلغاء الاشتراك في رسائل البريد الإلكتروني أو التواصل مع فريق الدعم.</li>
                </ul>
            </div>
            
            <h4>6- خصوصية الأطفال</h4>
            <p>لا تقوم وصلة بجمع معلومات شخصية من الأطفال الذين تقل أعمارهم عن 13 عامًا عن عمد. إذا علمنا أننا جمعنا معلومات من طفل دون سن 13 عامًا بدون موافقة الوالدين، فسنتخذ خطوات لحذف المعلومات.</p>
            
            <h4>7- تغييرات على سياسة الخصوصية</h4>
            <p>قد نقوم بتحديث سياسة الخصوصية من وقت لآخر. سيتم نشر أي تغييرات في التطبيق، وسيتم إبلاغك بأي تغييرات كبيرة. نشجعك على مراجعة سياسة الخصوصية بشكل دوري للحصول على التحديثات.</p>
            
            <h4>8- الاتصال بنا</h4>
            <p>إذا كانت لديك أي أسئلة أو مخاوف بشأن سياسة الخصوصية هذه أو كيفية تعاملنا مع معلوماتك الشخصية، يرجى الاتصال بنا على:</p>
            
            <div class="contact-info">
                <p>
                    <strong> البريد الإلكتروني:</strong> <a href="mailto:support@waslaapp.com"> support&#64;waslaapp.com</a>
                </p>
                <p>
                    <strong> الهاتف:</strong> <a href="tel:+201220566300"> 01220566300</a>
                </p>
            </div>
        </div>
    </div>
</div>


<app-footer-style-one></app-footer-style-one>